import React, {ChangeEvent} from 'react';
import {I18n} from 'react-redux-i18n';

import {Checkbox, FormControlLabel, withStyles, WithStyles} from '@material-ui/core';

import style from './style';
import ButtonCopy from '../ButtonCopy/ButtonCopy';

type ShowTOTPRecoveryCodeProps = WithStyles<typeof style> & {
  recoveryCode: string;
  isRecoveryCodeSaved: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsRecoveryCodeSaved: (val: boolean) => void;
};

function ShowTOTPRecoveryCode({
  classes,
  recoveryCode,
  isRecoveryCodeSaved,
  setIsRecoveryCodeSaved,
}: ShowTOTPRecoveryCodeProps) {
  return (
    <>
      <h2 className={classes.title}>
        {I18n.t('totp.setup.recoveryCode.title')}
      </h2>
      <p>
        {I18n.t('totp.setup.recoveryCode.description')}
      </p>
      <p className={classes.warningText}>
        {I18n.t('totp.setup.recoveryCode.warning')}
      </p>
      <div className={classes.recoveryCode__row}>
        <p className={classes.manualKeyEntering__secretText}>
          {recoveryCode}
        </p>
        <ButtonCopy
          id="recoveryCode"
          content={recoveryCode}
          snackbarMessage={I18n.t('totp.setup.recoveryCode.codeCopied')}
        />
      </div>
      <FormControlLabel
        control={(
          <Checkbox
            checked={isRecoveryCodeSaved}
            onChange={
              (e: ChangeEvent<HTMLInputElement>) => setIsRecoveryCodeSaved(e.target.checked)
            }
          />
        )}
        classes={{
          label: classes.checkbox__label,
        }}
        label={I18n.t('totp.setup.recoveryCode.confirm')}
      />
    </>
  );
}

export default withStyles(style)(ShowTOTPRecoveryCode);
